import { EMAIL_VALIDATOR } from '@farmnet/validators';
/**
 * Controller for the user settings in the settings page.
 */
angular.module('cfn').controller('userSettingsController', [
  '$scope',
  '$rootScope',
  '$log',
  '$dialog',
  'UpdateService',
  '$timeout',
  '$http',
  'CompanySettings',
  'UserSettings',
  'i18nFilter',
  'languageService',
  'changeEmailService',
  'farmnet.FeatureToggleService',
  'newsletterSubscriptionService',
  function(
    $scope,
    $rootScope,
    $log,
    $dialog,
    UpdateService,
    $timeout,
    $http,
    CompanySettings,
    UserSettings,
    i18nFilter,
    languageService,
    changeEmailService,
    featureToggleService,
    newsletterSubscriptionService
  ) {
    $scope.userSettingsController = this;
    $scope.emailValid = true;
    $scope.hasRight = app.hasRight;

    var controller = this;
    var unWatchSettings;
    var saveTimeout = null;
    var lastUserSettings = null;
    var lastUserSettingsString = null;

    function init() {
      controller.rights = app.credentials.rights;
      controller.newPassword = '';
      controller.newPassword2 = '';
      controller.addPromotionCode = '';
      controller.SaveTimeout = 500;
      controller.credentials = app.credentials;
      controller.passwordPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\S ]{6,}$/;
      controller.emailPopup = {
        isDisplayed: false,
        formData: {
          newEmail: '',
          newEmailConfirm: '',
        }
      };
      controller.pendingNewEmail = undefined;
      controller.newsletterStatus = {
        value: false, // represents the checkbox model state
        isPending: false, // represents the checkbox enabled state
        state: 'UNSUBSCRIBED',
      };
      controller.changePasswordError = {
        message: '',
        isDisplayed: false
      };
      controller.emailPattern = EMAIL_VALIDATOR;

      UserSettings.get({}, function(userSettings) {
        controller.userSettings = userSettings;
        lastUserSettingsString = JSON.stringify(userSettings);
        unWatchSettings = watchSettings();
      });

      controller.isExternalPartnerUser = !!controller.credentials.userProperties['com.365farmnet.partner.id'];
      controller.usernameLabel = controller.isExternalPartnerUser ?
        i18nFilter('fe.admin.settings.external.username') : i18nFilter('fe.register.username');

      initEmailChangeData();
      initNewsletterStatus();
    }
    init();

    function initEmailChangeData() {
      changeEmailService
        .getLatestEmailChange()
        .then(
          function(latestChange) {
            if (latestChange.data &&
                latestChange.data.email &&
                latestChange.data.status === 'OPEN') {
              controller.pendingNewEmail = latestChange.data.email;
            }
          },
          function(error) {
            console.error('ERROR retrieving email changes:', error);
          }
        );
    }

    function initNewsletterStatus() {
      newsletterSubscriptionService
        .getNewsletterStatus()
        .then(
          function (response) {
            controller.newsletterStatus.value =
              response.data.status !== 'UNSUBSCRIBED';

            controller.newsletterStatus.isPending =
              response.data.status.endsWith('PENDING');

            controller.newsletterStatus.state =
              response.data.status;
          },
          function (error) {
            console.error('[ERROR] Retrieving newsletter status:', error);
          }
        );
    }

    /**
     * Returns the value of the flag emailValid.
     * The value is set by the directive dValidateEmail.
     */
    $scope.hasEmailError = function() {
      return !$scope.emailValid;
    };

    // CFNPOC-5439: Don't show 'Firma' as an option
    $scope.addressFormAnredeEnumOptions = $rootScope.enums.AddressFormEnum.options.filter(
      function(option) {
        return option !== 'FIRM';
      }
    );

    this.languages = languageService.getSupportedPrimaryLanguagesNativeArray()
      .filter(lang => !(lang.key === 'pl' &&  app.credentials.company.countryIsoCode === 'CHE' ));

    this.checkPassword = function() {
      return (
        $scope.userSettingsForm.oldPassword.$modelValue &&
        $scope.userSettingsForm.oldPassword.$valid &&
        $scope.userSettingsForm.newPassword.$modelValue &&
        $scope.userSettingsForm.newPassword.$valid &&
        $scope.userSettingsForm.newPassword2.$modelValue &&
        $scope.userSettingsForm.newPassword2.$valid
      );
    };

    this.comparePassword = function() {
      return (
        $scope.userSettingsForm.newPassword.$modelValue ===
        $scope.userSettingsForm.newPassword2.$modelValue
      );
    };
    /**
     * Changes the account password if valid new password has been specified.
     */
    this.changePassword = function() {
      $http
        .put('/365FarmNet/rest/userSettings/password', {
          oldPassword: controller.oldPassword,
          newPassword: controller.newPassword
        })
        .then(function() {
          $rootScope.alertController.addTemporaryAlert(
            i18nFilter(
              'fe.admin.settings.changePassword.ok',
              'Neues Passwort gesetzt'
            ),
            'success'
          );
          controller.oldPassword = '';
          controller.newPassword = '';
          controller.newPassword2 = '';
        }, function (error) {
          controller.changePasswordError.message = error.data;
          controller.changePasswordError.isDisplayed = true;
        });
    };

    this.openChangeEmailPopup = function() {
      controller.emailPopup.isDisplayed = true;
    };

    this.hasEmailMismatch = function() {
      return controller.emailPopup.formData.newEmail !==
        controller.emailPopup.formData.newEmailConfirm;
    };

    this.resendEmailChangeConfirmationMail = function() {
      if (controller.pendingNewEmail) {
        changeEmailService.resendConfirmationMail(
          controller.pendingNewEmail
        ).then(
          function (response) {
            $rootScope.alertController.addTemporaryAlert(
              i18nFilter(
                'fe.admin.settings.changeEmail.changeSuccessMessage',
                'Wir haben Ihnen eine Bestätigungsmail an Ihre neue E-Mail-Adresse gesendet.'
              ),
              'success'
            );
          },
          function (error) {
            console.log('ERROR:', error);

            $rootScope.alertController.addTemporaryAlert(
              i18nFilter(
                'fe.admin.settings.changeEmail.resendErrorMessage',
                'Beim erneuten Senden der Bestätigungsmail ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.'
              ),
              'error'
            );
          }
        );
      }
    };

    this.saveNewEmail = function() {
      changeEmailService.updateEmailAddress(
        controller.emailPopup.formData.newEmail
      ).then(
        function (response) {
          controller.emailPopup.isDisplayed = false;
          controller.emailPopup.formData.newEmail = '';
          controller.emailPopup.formData.newEmailConfirm = '';

          $rootScope.alertController.addTemporaryAlert(
            i18nFilter(
              'fe.admin.settings.changeEmail.changeSuccessMessage',
              'Wir haben Ihnen eine Bestätigungsmail an Ihre neue E-Mail-Adresse gesendet.'
            ),
            'success'
          );

          initEmailChangeData();
        },
        function (error) {
          console.log('ERROR:', error);

          $rootScope.alertController.addTemporaryAlert(
            i18nFilter(
              'fe.admin.settings.changeEmail.changeErrorMessage',
              'Beim Ändern Ihrer E-Mail-Adresse ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.'
            ),
            'error'
          );
        }
      );
    };

    this.setNewsletterStatus = function () {
      newsletterSubscriptionService.setNewsletterStatus(
        controller.newsletterStatus.value
      ).then(
        function (response) {
          console.log('SUCCESS:', response);
          $rootScope.alertController.addTemporaryAlert(
              i18nFilter('fe.common.savedMsg', 'Änderungen gespeichert'), 'success'
          );

          initNewsletterStatus();
        },
        function (error) {
          console.log('ERROR setting newsletter status:', error);
        }
      );
    };

    this.resendNewsletterConfirmationMail = function() {
      newsletterSubscriptionService
        .resendConfirmationMail()
        .then(
          function () {
            $rootScope.alertController.addTemporaryAlert(
              i18nFilter(
                'fe.admin.settings.newsletter.resendSuccessMessage',
                'Wir haben Ihnen erneut eine Bestätigungsmail an Ihre E-Mail-Adresse gesendet.'
              ),
              'success'
            );
          },
          function (error) {
            console.log('ERROR trying to access resend endpoint:', error);
            
            $rootScope.alertController.addTemporaryAlert(
              i18nFilter(
                'fe.admin.settings.newsletter.resendErrorMessage',
                'Bitte bestätigen Sie zuerst Ihre E-Mail-Adresse.'
              ),
              'error'
            );
          }
        );
    };

    // save part

    controller.setSavedState = function(userSettings) {
      var hasErrors = controller.checkBEValidationChanges();
      lastUserSettings = userSettings;
      lastUserSettingsString = JSON.stringify(userSettings);
      return hasErrors;
    };

    controller.doSave = function(settings) {
      if ($scope.saving) {
        // prevent if already saving
        console.debug('save canceled', controller.userSettings);
        // try save again after some time if $scope.saving allows
        if (saveTimeout != null) {
          $timeout.cancel(saveTimeout);
        }
        saveTimeout = $timeout(function() {
          controller.doSave(controller.userSettings);
        }, controller.SaveTimeout);
        return;
      }

      if ($scope.hasEmailError()) return;

      $scope.saving = true;
      $http
        .put('/365FarmNet/rest/userSettings', settings)
        .then(
          function(response) {
            var data = response.data;
            // update data from result.
            controller.userSettings.messagingContext = data.messagingContext;
            var hasErrors = controller.setSavedState(controller.userSettings);

            // Use language returned from backend as it contains region information
            app.showLoader();
            if(languageService.getLanguage() !== data.uiLocale) {
              parent.postMessage({
                type: 'fnw-credentials-change',
                serviceName: ''
              }, location.origin);
            } else {
              $rootScope.alertController.addTemporaryAlert(
                  i18nFilter('fe.common.savedMsg', 'Änderungen gespeichert'), 'success'
              );
              app.hideLoader();

            }


          },
          function(response) {
            var data = response.data;
            if (data) {
              unWatchSettings();
              controller.userSettings = data.errorSettings;
              lastUserSettingsString = JSON.stringify(controller.userSettings);
              unWatchSettings = watchSettings();
            }
          }
        )
        .finally(function() {
          'use strict';
          $scope.saving = false;
        });
    };

    function processAccountOwnerEmailChange() {
      var userSettings = controller.userSettings;
      var userSettingsString = JSON.stringify(userSettings);
      var newContactEmail = JSON.parse(userSettingsString).contactEmail;
      if (JSON.parse(lastUserSettingsString).contactEmail !== newContactEmail) {
        /*
             * Every change of the E-Mail in the userSettings UI (userSettingsController) also has to be displayed
             * in the companySettings UI (companySettingsController). So the companySettingsController has to be noticed,
             * that the E-Mail was changed by the userSettingsController. This is done by emitting an event.
             * Since both controllers exist side by side in the scope-hierarchy they cannot send and receive events directly to
             * each other. Therefore instead of sending an event_1 upwards from userSettingsController to settingsController
             * and then sending an event_2 downwards to the companyController we use a shortcut by directly sending the event
             * over the parent scope as '$scope.$parent.$broadcast(...)'.
             */
        $scope.$parent.$broadcast('userSettingsAccountOwnerEmailChanged', {
          newEmail: newContactEmail
        });
      }
    }

    function watchSettings() {
      // TODO: this actually might be a bit to slow to watch for EVERYTHING
      return $scope.$watch(
        'ctrl.userSettings',
        function() {
          var userSettings = controller.userSettings;
          var userSettingsString = JSON.stringify(userSettings);
          var isSettingsNotLoaded =
            userSettings == null || userSettings === undefined;

          if (isSettingsNotLoaded && lastUserSettings != null) {
            if (saveTimeout != null) {
              $timeout.cancel(saveTimeout);
              saveTimeout = null;

              controller.doSave(lastUserSettings);
              lastUserSettingsString = null;
            }
            lastUserSettings = null;
            return;
          }
          // skip initial change
          var isFirstWatch = lastUserSettings == null;

          if (isFirstWatch) {
            lastUserSettings = userSettings;
            return;
          }
          // only save if the form actually is dirty
          var isSettingsDirty = lastUserSettingsString !== userSettingsString;
          if (isSettingsDirty) {
            if (saveTimeout != null) {
              $timeout.cancel(saveTimeout);
            }
            saveTimeout = $timeout(function() {
              controller.doSave(userSettings);
              saveTimeout = null;
            }, controller.SaveTimeout);
            processAccountOwnerEmailChange();
          }
          lastUserSettings = userSettings;
          lastUserSettingsString = userSettingsString;
        },
        true
      );
    }

    // end save part

    /**********************************start validation***********************************************/

    var vgi = {};

    vgi['alternateEmail'] = '1';
    vgi['alternateSms'] = '1';

    var validationGroupInfo = vgi;
    var validationForm = $("form[name='userSettingsForm']");

    function getContentByKey(key) {
      var k = key;
      if (k.indexOf('__') !== -1) {
        k = k.substr(0, k.indexOf('__'));
      }
      var content = validationGroupInfo[k];
      return content;
    }

    controller.updateBEValidation = function() {
      var hasErrors = false;
      var tabErrors = {};
      controller.beValidationFields = {};
      if (controller.userSettings && controller.userSettings.messagingContext) {
        var context = controller.userSettings.messagingContext;
        for (var i in context.messages) {
          var msg = context.messages[i];
          if (!msg.key || msg.key === '') {
            controller.beValidationFields[msg.value] = true; // store already done validation
            if (msg.type === 'ERROR') {
              $rootScope.alertController.addTemporaryAlert(msg.value, 'error');
            } else {
              $rootScope.alertController.addTemporaryAlert(
                msg.value,
                'warning'
              );
            }
          }
          if ((msg.type === 'ERROR' || msg.type === 'WARNING') && msg.key) {
            var tab = getContentByKey(msg.key);
            if (!tab) {
              console.debug('Tab for ' + msg.key + ' not found');
            } else {
              if ($('#tabContent' + tab).is(':visible')) {
                controller.beValidationFields[msg.key] = true;
                if (msg.type === 'ERROR') {
                  $('#' + msg.key).validationEngine(
                    'showPrompt',
                    msg.value,
                    'error',
                    undefined,
                    true
                  );
                  hasErrors = true;
                } else {
                  //TODO: Style for Warnings
                  $('#' + msg.key).validationEngine(
                    'showPrompt',
                    msg.value,
                    'error',
                    undefined,
                    true
                  );
                }
              } else {
                if (!tabErrors[tab]) {
                  tabErrors[tab] = 0;
                }
                tabErrors[tab]++;
              }
            }
          }
        }
        for (var errorTab in tabErrors) {
          var errorCount = tabErrors[errorTab];
          $('#tabHeader' + errorTab).validationEngine(
            'showPrompt',
            errorCount + ' Fehler',
            'error',
            undefined,
            true
          );
          $('#tabHeader' + errorTab).off('click.cfn'); // remove old
          // handler
          $('#tabHeader' + errorTab).on('click.cfn', function() {
            $('#tabHeader' + errorTab).validationEngine('hide');
            hasErrors = controller.checkBEValidationChanges();
          });
        }
      }
      return hasErrors;
    };
    controller.checkBEValidationChanges = function() {
      var hasErrors = false;
      if (
        controller.userSettings &&
        controller.userSettings.messagingContext &&
        controller.beValidationFields
      ) {
        var oldFields = controller.beValidationFields;
        controller.beValidationFields = [];
        var context = controller.userSettings.messagingContext;
        for (var i in context.messages) {
          var msg = context.messages[i];
          if (!msg.key || msg.key === '') {
            controller.beValidationFields[msg.value] = true; // store already done validation
            if (!oldFields[msg.value]) {
              if (msg.type === 'ERROR') {
                $rootScope.alertController.addTemporaryAlert(
                  msg.value,
                  'error'
                );
              } else {
                $rootScope.alertController.addTemporaryAlert(
                  msg.value,
                  'warning'
                );
              }
            }
          }

          if ((msg.type === 'ERROR' || msg.type === 'WARNING') && msg.key) {
            // neues prompt !
            controller.beValidationFields[msg.key] = true;

            var tab = getContentByKey(msg.key);
            if (!tab) {
              console.debug('Tab for ' + msg.key + ' not found');
            } else {
              $log.debug('new prompt', msg.key);
              if ($('#tabContent' + tab).is(':visible')) {
                controller.beValidationFields[msg.key] = true;
                if (msg.type === 'ERROR') {
                  $('#' + msg.key).validationEngine(
                    'showPrompt',
                    msg.value,
                    'error',
                    undefined,
                    true
                  );
                  hasErrors = true;
                } else {
                  //TODO: Style for Warnings
                  $('#' + msg.key).validationEngine(
                    'showPrompt',
                    msg.value,
                    'error',
                    undefined,
                    true
                  );
                }
              }
            }
          }
        }
        for (var key in oldFields) {
          if (!controller.beValidationFields[key]) {
            try {
              $('#' + key).validationEngine('hide');
              $('.' + key + 'formError').remove();
            } catch (e) {
              $log.debug('error in closing ', e);
            }
          }
        }
      }
      return hasErrors;
    };
    controller.removeValidation = function() {
      validationForm.validationEngine('hideAll');
      validationForm.validationEngine('detach');
    };
    controller.updateValidation = function() {
      $log.debug('update validation');
      setTimeout(function() {
        validationForm.validationEngine('attach', {
          relative: true,
          scroll: false,
          promptPosition: 'topLeft'
        });
      }, 0);
      setTimeout(function() {
        // only validate if already has been saved

        if (controller.userSettings && controller.userSettings.id) {
          validationForm.validationEngine('validate');
          controller.updateBEValidation();
        }
      }, 1000);
    };

    setTimeout(function() {
      controller.updateValidation();
    }, 0);
  }
]);
